<template>
  <BasicLayout v-slot:default="slotProps">
    <div class="page">
      <div class="page__content">
        <CheckoutProcess />
        <dl class="contract-number">
          <dt>Auftragsnummer: </dt>
          <dd>{{ slotProps.number }}</dd>
        </dl>
        <div>
          <h2>Herzlichen Glückwünch.</h2>
          <p class="sub-title-text">Ihre Bestellung ist bestätigt.</p>
          <Contacts />
        </div>
      </div>
      <SidebarSummary v-if="slotProps.car" :car="slotProps.car" :order="slotProps.order" />
    </div>
  </BasicLayout>
</template>

<script>
import SidebarSummary from '@/components/SidebarSummary';
import BasicLayout from '../components/layout/BasicLayout';
import CheckoutProcess from '../components/CheckoutProcess';
import Contacts from '../components/Contacts';

export default {
  components: {
    BasicLayout,
    CheckoutProcess,
    SidebarSummary,
    Contacts,
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 520;
    },
    isDesktop() {
      return window.innerWidth > 990;
    },
  },
};
</script>
